/**
 * 自有统计代码
 * author: michael wang
 */
 var $as = (function(win){
    // console.log('analytic-main-dev.js');
    var version = 'v1.0.0-2021.12.09-14:30';
    var COOKIE_NAME = 'ANALYTIC-SELF';
    // 2038: 2147483647
    var COOKIE_EXPIRES = 2147483647;
    // 0: dev, 1: pro
    var env = process ? (process.env.NODE_ENV === 'development'? 0 : 1) : 'dev';
    var dev = {
        serverAddress: 'http://52.81.101.191:8989/log',
    }
    var pro = {
        serverAddress: 'https://api.d4b80cba.com/log',
    }
    var SERVER_ADDRESS = env ? pro.serverAddress : dev.serverAddress;


    var tools = {
        getRandomStr: function(len) {
            var str = 'abcdefghijklmnopqrstuvwxyzABCDYFGHIJKLMNOPQRSTUVWXYZ0123456789';
            var strArr = str.split('');
            var ops = null;
            var result = '';
            
            if(len < 1) {
                return result;
            }

            for(var i = 0; i < len; i++) {
                ops = parseInt(Math.random() * str.length);

                if(strArr[ops]) {
                    result += strArr[ops];
                }else{
                    result += strArr[7]
                }
            }


            return result;
        },

        setCookie: function (name, value, expiredays) {
            var exdate = new Date();
            exdate.setTime(+new Date() + expiredays);
            document.cookie = name + '=' + escape(value) + ';path=/' + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString());
        },
    
        deleteCookie: function(name) {
            var exdate = new Date();
            exdate.setTime(+new Date() - 1);
            document.cookie = name + '=' + ';path=/' + ';expires=' + exdate.toGMTString();
        },
        
        getCookie: function (name) {
            var start, end;
        
            if (document.cookie.length > 0) {
                start = document.cookie.indexOf(name + '=');
                if (start !== -1) {
                    start = start + name.length + 1;
                    end = document.cookie.indexOf(';', start);
        
                    if (end === -1) {
                        end = document.cookie.length;
                    }
        
                    return unescape(document.cookie.substring(start, end));
                }
            }
            return '';
        },

        getLang: function(){
            var langArr = [];
            var language = win.navigator.language.toLowerCase();
    
            if(language.indexOf('-') > -1){
                langArr = language.split('-');
            }else{
                langArr[0] = language;
            }
    
            return langs[langArr[0]] || langs['en'];
        },
    
        getQueryString: function(url, key) {
            var urlObj = new URL(url);
            var val = '';
    
            try {
                val = urlObj.searchParams.get(key);
            }catch(e) {
                val = '';
            }
    
            return val;
        },
    
        ajax: function(opts){
    
            var options = {
                url: '',
                type: 'GET',
                data: null,
                timeout: 30,
                contentType: 'application/x-www-form-urlencoded',
                success: function(){},
                error: function(){},
                timeoutFn: function(){
                    // alert("Network error,check your internet connection and try again");
                }
            };
    
            if(!opts.url || !opts.type){
                return;
            }
    
            for(var i in opts){
                options[i] = opts[i];
            }
    
            function callback (xhr) {
                // alert('xmlhttp.status = ' + xmlhttp.status + ' xmlhttp.readyState = ' + xmlhttp.readyState);
                var showError = function(){
                    if(xmlhttp.responseText.indexOf('401') > -1){
                        alert(' xmlhttp.responseText = ' + xmlhttp.responseText);
                    }else{
                        alert('xmlhttp.status = ' + xmlhttp.status + ' xmlhttp.responseText = ' + xmlhttp.responseText);
                    }
                }
                
                xmlhttp.boxNetStatus = 1;
                if(xmlhttp.readyState == 4){
                    clearTimeout(xmlHttpTimeout); 
                    // status == 0, 时可能出现问题, 本地响应, 断网时会出现
                    if(xmlhttp.status == 200 || xmlhttp.status == 0){
                        // 本地响应, 断网处理
                        if(xmlhttp.status == 0 && !xmlhttp.responseText){
                            xmlhttp.boxNetStatus = 0;
                            options.error(xmlhttp);
                        }else{
                            options.success(xmlhttp.responseText);
                            clearTimeout(xmlHttpTimeout);
                        }
                    }else if(xmlhttp.status == 401){
                        if(win.account){
                            win.account.gotoLogin();
                        }else{
                            // showError();
                            options.error(xmlhttp);
                        }
                    }else if(xmlhttp.status == 400){
                        options.error(xmlhttp);
                        clearTimeout(xmlHttpTimeout);
                    }else{
                        // 按超时处理, 不清除 clearTimeout(xmlHttpTimeout)
                    }
                }
            }
    
            var xmlhttp = new XMLHttpRequest();
            var xmlHttpTimeout = null;

            xmlhttp.onreadystatechange = callback ;
    
            if(options.type=='GET'){
                var u = '';
    
                if(options.data){
                    for(var di in options.data){
                        u += di + '=' + options.data[di] + '&';
                    }
    
                    u = options.url + '?' + u.substring(0, u.length - 1);
                }else{
                    u = options.url;
                }
                xmlhttp.open(options.type, u, true);
                xmlhttp.send(null);
            }else if(options.type == 'POST'){
                xmlhttp.open(options.type, options.url, true);
                xmlhttp.setRequestHeader("Content-Type", options.contentType);
    
                var formStr = '';
                var sp = '&';
                
                if(options.contentType == 'application/json'){
                    xmlhttp.setRequestHeader('accept', options.contentType)
                    formStr = options.data;
                }else{
                    if(!options.data) return '';
                    var pairs = [];
                    for(var name in options.data){
                        if(!options.data.hasOwnProperty(name)) 
                            continue;
                        if(typeof options.data[name] === 'function') 
                            continue;
    
                        var value = options.data[name].toString();
                        name = encodeURIComponent(name.replace('%20','+'));
                        value = encodeURIComponent(value.replace('%20','+'));
                        pairs.push(name+'='+value);
                    }
                    formStr = pairs.join('&');
                }
    
                // xmlhttp.setRequestHeader("xbid",uuid);
                
                xmlhttp.send(formStr);
    
            }
    
            xmlHttpTimeout = setTimeout(ajaxTimeout , options.timeout * 1000);
    
            function ajaxTimeout(){
                xmlhttp.abort();
                options.timeoutFn();
            }
        }
    };

    // 公开对象
    return {
        ver: version,
        // args: [eventName, ...]
        // eventName: 动作_
        send: function(args) {
            var opts = {};
            var ck = tools.getCookie(COOKIE_NAME) || null;
            var cv = 'as-' + tools.getRandomStr(8) + '-' + +new Date;
            var eventName = 'show_page';

            if(typeof args === 'string') {
                eventName = args;
            }else if(args instanceof Array) {
                eventName = args[0];
            }else {
                return;
            }
            
            opts.event_name = eventName;
            opts.event_source = win.location.href;
            opts.host_name = win.location.host || win.location.hostname;
            opts.origin = win.location.origin;
            opts.search = win.location.search || '';
            opts.ts = +new Date;
            opts.ua = win.navigator.userAgent;
            opts.language = win.navigator.language || '';

            if(ck) {
                opts.ck = ck;
            }else {
                tools.setCookie(COOKIE_NAME, cv, COOKIE_EXPIRES);
                opts.ck = cv;
            }

            tools.ajax({
                url: SERVER_ADDRESS,
                data: opts,
                type: 'POST',
                success: function(d) {
                    var resData = null

                    // 请求成功, 再跳转到 GP
                    try {
                        if(d) {
                            resData = JSON.parse(d);
                            if(resData.status.code == 0) {
                                // console.log('发送成功');
                            }
                        }
                    }catch(e) {
                        // console.log('发送异常');
                    }
                },
                error: function(e) {
                    // console.log('发送失败');
                }
            });
        }
    }
})(window);

export default {
    "$as": $as
}